/**
 * The shell every result row wears.
 *
 * `PatientResultRow`, `CallerResultRow` and `FollowUpResultRow` sit side by side
 * on the dashboard, and the same patient row appears again under the search
 * field. Anything one does differently — an avatar on one and not the other, a
 * row a size shorter, a row that starts left of its own card title — reads as a
 * mistake rather than as a distinction.
 *
 * Held in one constant for the same reason `BUTTON_BASE` is: three copies of a
 * class string are three things to keep in step, and the follow-up row had
 * already fallen out of it. It was written inline on the dashboard rather than
 * beside the other two, and lost its horizontal padding along the way — so its
 * content, and the hover highlight with it, ran to the card's edges while its
 * neighbours stayed inset. That is what "the content is leaking" looks like.
 *
 * `min-h-row` (56px) is the floor, not the height: a wrapped name grows the row
 * rather than being clipped by it.
 */
export const RESULT_ROW =
  'group flex min-h-row w-full items-center gap-3 bg-surface px-4 py-2 text-left text-fg no-underline transition-colors duration-150 ease-standard hover:bg-hover'

/** The chevron at the end of one, which moves to say the row is a way through. */
export const RESULT_ROW_CHEVRON =
  'text-fg-subtle transition-transform duration-150 ease-standard group-hover:translate-x-0.5 group-hover:text-accent'
